import { useEffect } from 'react';

import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import useUnitAccount from '#client/hooks/useUnitAccount';

import FieldDetail from '../FieldDetail';
import MoneyDetail from '../MoneyDetail';

const INSTANT_DEPOSIT_STATUS_TEXT = {
  PROCESSING: 'Processing',
  COMPLETE: 'Complete'
};

export default function InstantDepositDetail({
  amount,
  dateInitiated,
  transferType,
  status,
  subTitle,
  title = 'Transaction details',
  transactionType
}) {
  const { unitAccount, refetch, loading: unitAccountLoading } = useUnitAccount();

  useEffect(() => {
    // Get the lasted balance when instant deposit completely
    if (status === INSTANT_DEPOSIT_STATUS_TEXT.COMPLETE) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', lg: '56px' }}
      pt={{ xs: '24px', lg: '32px' }}
      px={{ xs: '24px', lg: '32px' }}
      rowSpacing={{ xs: '16px', lg: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            {title}
          </Text>
        </Stack>
        {subTitle && (
          <Text
            align="left"
            color="tertiary"
            size="sm"
          >
            {subTitle}
          </Text>
        )}
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <MoneyDetail
            label="Amount"
            value={amount}
          />
        </Grid>
      </Grid>
      <FieldDetail
        label="Date initiated"
        value={dateInitiated}
      />
      <FieldDetail
        label="Transaction type"
        value={transactionType}
      />
      <FieldDetail
        label="Account balance"
        loading={unitAccountLoading}
        value={unitAccount?.balance?.formattedAmount}
      />
      <FieldDetail
        label="Status"
        value={status}
      />
      <FieldDetail
        label="Transfer type"
        value={transferType}
      />
    </Grid>
  );
}

InstantDepositDetail.propTypes = {
  amount: PropTypes.string,
  dateInitiated: PropTypes.string,
  transferType: PropTypes.string,
  status: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string,
  transactionType: PropTypes.string
};
